import { useMedia } from 'react-use'

const useScreenSize = () => {
  const isSmallScreen = useMedia('(max-width: 1440px)')
  const containerClass = isSmallScreen ? 'w-1/2' : 'w-1/2'

  return containerClass
}

export default useScreenSize
